import { SearchOperator } from "../models/SearchParam";
import type { FinancialEntry } from "../models/FinancialEntry";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";

export function FinancialEntryService(type?: import("../models/FinancialEntry").FinancialEntryType) {
  return CreateCrudService<FinancialEntry, KeyValue>({
    Route: "finance",
    PaginationInPath: true,
    BaseFilters: type ? [{Field:"Type",Operator:SearchOperator.EQ,Value:type}] : [],
    EntityName: "Finance",
    PartialFields: ["Code", "Description"],
    LoadingMessage: "Loading financial entries...",
    SavingMessage: "Saving financial entry...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.Description ?? value.Code ?? ""),
    }),
  });
}
